import React from 'react'


export default class SettingProxy extends React.Component{



    render(){
        const {Setting} = this.props
        return (
            <Setting ecId={`${this && this.props && this.props.ecId || ''}_Setting@qtg5ky`} ref='Setting' {...this.props}></Setting>
        )

    }

}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4coms/menuPerfect/components/settingProxy.js